var Manufacturers = function () {

    this.init = function () {

        submitBuilderEvent();

        clickBuilderEvent();

        if ($("[data-component='manufacturers']").parent().find(".formEquipmentBuilder").data("query")) {

            var Query = $(".formEquipmentBuilder").data("query");
            var ComponentID = $(".formEquipmentBuilder").data("id");
            var form = $(".formEquipmentBuilder");

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Manufacturers/SearchEquipment",
                data: JSON.stringify({ "Query": Query, "ComponentID": ComponentID }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    getManufacturers(form, response);
                },
                error: function (e) {

                }
            });

            $("html, body").animate({ scrollTop: $(".formEquipmentBuilder").position().top - 100 }, "slow");
        }
    }

    var submitBuilderEvent = function () {

        $(".formEquipmentBuilder").submit(function (e) {

            $("#searchLoad").show();
            $(".formEquipmentBuilder").parents().find('.manufacturers').hide();
            $(".formEquipmentBuilder").find(".btn-search").attr("disabled", true);

            e.preventDefault();

            var Query = $(this).find("input[name='search']").val();
            var ComponentID = $(this).data("id");
            var form = $(this);

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Manufacturers/SearchEquipment",
                data: JSON.stringify({ "Query": Query, "ComponentID": ComponentID }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    if ($("[data-page='componente-interno']").length > 0)
                        getManufacturersProduct(form, response);
                    else
                        getManufacturers(form, response);

                    $("#searchLoad").hide();
                    $(".formEquipmentBuilder").parents().find('.manufacturers').show();
                },
                error: function (e) {

                },
                complete: function (data) {
                    $(".formEquipmentBuilder").find(".btn-search").attr("disabled", false);
                }
            });
        });
    };

    var clickBuilderEvent = function () {

        $(".equipmentBuilderShow").click(function (e) {

            e.preventDefault();

            var ComponentID = $(this).data("id");
            var form = $(this);

            form.addClass('loading');

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Manufacturers/ShowAll",
                data: JSON.stringify({ "ComponentID": ComponentID }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    form.removeClass('loading');

                    getManufacturers(form, response);

                    form.hide();
                },
                error: function (e) {

                }
            });
        });
    };

    var getManufacturers = function (form, response) {

        var rowAppend = form.parents(".container").find("[data-component='manufacturers']").find(".row");
        rowAppend.empty();

        if (response.length > 0) {

            $(".manufacturersFail p").hide();
            $("[data-component='manufacturers']").find("h3").show();

            var html = "";

            for (var i = 0; i < response.length; i++) {

                var item = response[i];

                html += '<div class="col-md-4 col-sm-6 col-xs-6">';
                html += '   <div class="edit-p">';
                html += '       <a href="' + item.URL + '" style="font-size: 20px; color: #6e6e6e;">' + item.Title + '</a>';
                html += '   </div>';
                html += '</div>';
            }

            rowAppend.append(html);
        }
        else {

            $(".manufacturersFail p").show();
            $("[data-component='manufacturers']").find("h3").hide();
        }
    };

    var getManufacturersProduct = function (form, response) {

        var rowAppend = form.find(".manufacturers");
        rowAppend.empty();

        if (response.length > 0) {

            $(form).find(".result").text("Resultado:");
            $(form).find(".result").show();

            var html = '';
            
            for (var i = 0; i < response.length; i++) {

                var item = response[i];

                if (i % 3 == 0)
                    html += '<div class="row">';

                html += '<div class="col-md-4">';
                html += '   <div class="manufacturer">';
                html += '       <a href="' + item.URL + '">' + item.Title + '</a>';
                html += '   </div>';
                html += '</div>';

                if (i % 3 == 2)
                    html += '</div>';
            }

            rowAppend.append(html);
            rowAppend.show();
        }
        else {

            $(form).find(".result").text("Nenhum resultado encontrado");
            $(form).find(".result").show();
        }
    };

    return this.init();
}
